export const CREATE_MEETING = `
  mutation CreateMeeting($tenant_id: Int!, $data: CreateMeetingInput!) {
    createMeeting(tenant_id: $tenant_id, data: $data) {
      __typename

      ... on Meeting {
        id
        tenant_id
        group_id
        month
        current_date
        current_date_2
        type
        rg1_mode
        rg2_mode
        ret_mode
        comments
        draft
        done
        current_host_id
        guests
        meetings
        has_presenter
        is_hired_presenter
        current_presenter_id
        current_presentation_id
        extra_presenter
        extra_presenter_email
        extra_presentation
        pay_mode
        pay
        extra_pay
        expenses
        only_presentation
        its
        uts
        group {
          id
          name
        }
        current_host {
          id
          firstname
          lastname
        }
        current_presenter {
          id
          contact {
            id
            firstname
            lastname
          }
        }
      }

      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export const UPDATE_MEETING = `
  mutation UpdateMeeting($tenant_id: Int!, $data: UpdateMeetingInput!) {
    updateMeeting(tenant_id: $tenant_id, data: $data) {
      __typename

      ... on Meeting {
        id
        tenant_id
        group_id
        month
        current_date
        current_date_2
        type
        rg1_mode
        rg2_mode
        ret_mode
        comments
        draft
        done
        current_host_id
        guests
        meetings
        has_presenter
        is_hired_presenter
        current_presenter_id
        selected_topic_id
        topic {
          id
          title
        }
        current_presentation_id
        extra_presenter
        extra_presenter_email
        extra_presentation
        pay_mode
        pay
        extra_pay
        expenses
        only_presentation
        its
        uts
        group {
          id
          name
        }
        current_host {
          id
          firstname
          lastname
        }
        current_presenter {
          id
          contact {
            id
            firstname
            lastname
          }
        }
      }

      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export const DELETE_MEETING = `
  mutation DeleteMeeting($tenant_id: Int!, $id: Int!) {
    deleteMeeting(tenant_id: $tenant_id, id: $id) {
      __typename

      ... on Meeting {
        id
      }

      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export const UPDATE_MEETING_MEMBER = `
  mutation UpdateMeetingMember($tenant_id: Int!, $data: UpdateMeetingMemberInput!) {
    updateMeetingMember(tenant_id: $tenant_id, data: $data) {
      __typename

      ... on MeetingMember {
        id
        group_done
        group_done_2
        meeting_121_done
        critical
        critical_topic
        answered
        absence_comment
        member {
          id
          contact {
            id
            firstname
            lastname
          }
        }
      }

      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export const FINALIZE_MEETING_AND_SEND_EVALUATIONS = `
  mutation FinalizeMeetingAndSendEvaluations($meetingId: Int!, $tenant_id: Int!, $groupIds: [Int!]) {
    finalizeMeetingAndSendEvaluations(meetingId: $meetingId, tenant_id: $tenant_id, groupIds: $groupIds) {
      __typename

      ... on EvaluationOperationResult {
        success
        message
        count
      }

      ... on ResultError {
        status_code
      }
    }
  }
`;

export const GENERATE_EVALUATION_LINKS = `
  mutation GenerateEvaluationLinks($meetingId: Int!, $tenant_id: Int!) {
    generateEvaluationLinks(meetingId: $meetingId, tenant_id: $tenant_id) {
      __typename

      ... on EvaluationOperationResult {
        success
        message
      }

      ... on ResultError {
        status_code
      }
    }
  }
`;

export const RESEND_EVALUATION_EMAIL = `
  mutation ResendEvaluationEmail($meetingMemberId: Int!) {
    resendEvaluationEmail(meetingMemberId: $meetingMemberId) {
      __typename

      ... on EvaluationOperationResult {
        success
        message
      }

      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export const UPDATE_MEETING_MEMBER_EVALUATION = `
  mutation UpdateMeetingMemberEvaluation($meetingMemberId: Int!, $input: EvaluationInput!) {
    updateMeetingMemberEvaluation(meetingMemberId: $meetingMemberId, input: $input) {
      __typename

      ... on MeetingMember {
        id
        member_id
        answered
        question_1
        question_2
        question_3
        question_4
        question_5
        group_comments
        presenter_comments
        exhibitor_absent
        answer_date
        uts
        member {
          id
          contact {
            id
            firstname
            lastname
          }
        }
      }

      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export const SUBMIT_EVALUATION = `
  mutation SubmitEvaluation($hash: String!, $input: EvaluationInput!) {
    submitEvaluation(hash: $hash, input: $input) {
      __typename

      ... on EvaluationOperationResult {
        success
        message
      }

      ... on ResultError {
        status_code
      }
    }
  }
`;

export const SUBMIT_MEETING_EVALUATION = `
  mutation SubmitMeetingEvaluation($hash: String!, $meetingMemberId: Int!, $input: EvaluationInput!) {
    submitMeetingEvaluation(hash: $hash, meetingMemberId: $meetingMemberId, input: $input) {
      __typename

      ... on EvaluationOperationResult {
        success
        message
      }

      ... on ResultError {
        status_code
      }
    }
  }
`;
